import React from 'react';

export interface PaymentSummarySectionProps {
  unlinkedPaymentsCount: number;
  unlinkedPaymentsTotal: number;
  linkedPaymentsCount: number;
  linkedPaymentsTotal: number;
}

export const PaymentSummarySection: React.FC<PaymentSummarySectionProps> = ({
  unlinkedPaymentsCount,
  unlinkedPaymentsTotal,
  linkedPaymentsCount,
  linkedPaymentsTotal,
}) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
      }}
    >
      {/* תשלומים לא מקושרים */}
      <div
        style={{
          flex: 1,
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '8px',
          border: '1px solid #e0e0e0',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {/* Icon Section */}
          <div
            style={{
              width: '48px',
              minWidth: '48px',
              height: '48px',
              backgroundColor: '#D7EBFF',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className="pi pi-file"
              style={{ fontSize: '1.5rem', color: '#2196F3' }}
            />
          </div>

          {/* Content Section */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              gap: '8px',
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#041E49',
              }}
            >
              תשלומים לא מקושרים
            </div>
            <div
              style={{
                fontSize: '12px',
                color: '#666',
                lineHeight: '1.5',
                marginBottom: '4px',
              }}
            >
              תשלומים היסטורים שאינם מקושרים לשירותי התשלום
              <br />
              ניתן לצפייה בטאב ״תשלומים לא מקושרים״
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span style={{ color: '#666', fontSize: '14px' }}>כמות:</span>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {unlinkedPaymentsCount}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span style={{ color: '#666', fontSize: '14px' }}>
                  סה״כ שולם:
                </span>
                <span
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    direction: 'ltr',
                    textAlign: 'right',
                  }}
                >
                  ₪{unlinkedPaymentsTotal < 0 ? '-' : ''}
                  {Math.abs(unlinkedPaymentsTotal).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* תשלומים מקושרים */}
      <div
        style={{
          flex: 1,
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '8px',
          border: '1px solid #e0e0e0',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {/* Icon Section */}
          <div
            style={{
              width: '48px',
              minWidth: '48px',
              height: '48px',
              backgroundColor: '#D7EBFF',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className="pi pi-link"
              style={{ fontSize: '1.5rem', color: '#2196F3' }}
            />
          </div>

          {/* Content Section */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              gap: '8px',
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#041E49',
              }}
            >
              תשלומים מקושרים
            </div>
            <div
              style={{
                fontSize: '12px',
                color: '#666',
                lineHeight: '1.5',
                marginBottom: '4px',
              }}
            >
              תשלומים המקושרים לשירותי תשלום,
              <br />
              כל תשלום חדש יקושר לשירות תשלום במערכת
              <br />
              ניתן לצפייה בטאב ״תשלומים מקושרים״
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span style={{ color: '#666', fontSize: '14px' }}>כמות:</span>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {linkedPaymentsCount}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span style={{ color: '#666', fontSize: '14px' }}>
                  סה״כ שולם:
                </span>
                <span
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    direction: 'ltr',
                    textAlign: 'right',
                  }}
                >
                  ₪{linkedPaymentsTotal < 0 ? '-' : ''}
                  {Math.abs(linkedPaymentsTotal).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
